// @flow
import React, { Component } from 'react';
import delay from 'lodash/delay';
import i18n from 'app/common/lib/i18n';
import SocialConnectButton from 'app/common/react/components/growth/unauth/signup/SocialConnectButton/SocialConnectButton';
import SocialNetworkSettingsManager from 'app/common/lib/SocialNetworkSettings';
import type { ExperienceClient } from 'app/common/lib/react/experiences/withExperienceClient';
import withExperienceClient from 'app/common/lib/react/experiences/withExperienceClient';
import { compose } from 'redux';
import { HeaderHeight } from 'app/common/react/components/Header/Context/ContextConsumer';
import { Box, IconButton, Text, Sticky } from 'gestalt';

type HeroProps = {|
  handleDismiss: () => void,
  subTitle: string,
  facebookConnectSuccess: string,
  gplusConnectSuccess: string,
  connectWithGoogle: string,
  connectWithFacebook: string,
  experienceClient: ExperienceClient,
  experienceId: number,
  successMsgCloseDelayInMills: number,
|};

type State = {|
  network: string,
|};

export class SocialConnectUpsellHero extends Component<HeroProps, State> {
  state: State = {
    network: '',
  };

  setConnectSuccess = (network: string) => {
    this.setState({ network }, this.handleComplete);
  };

  getText() {
    if (this.state.network === '') {
      return this.props.subTitle;
    } else if (this.state.network === 'gplus') {
      return this.props.gplusConnectSuccess;
    } else {
      return this.props.facebookConnectSuccess;
    }
  }

  handleComplete() {
    const preventRemoveExperience = true;
    delay(
      (placementId, experienceId, isRemoveExperience) => {
        this.props.experienceClient.completeExperience(
          placementId,
          experienceId,
          isRemoveExperience,
        );
      },
      this.props.successMsgCloseDelayInMills,
      PCONST.thrift.Placement.WEB_HOME_TAKEOVER,
      this.props.experienceId,
      preventRemoveExperience,
    );
  }

  handleSocialConnectClick = (network: string) => {
    const socialManager = SocialNetworkSettingsManager.instance();
    socialManager.handleConnect(network, true, {
      success: () => {
        this.setConnectSuccess(network);
      },
      error: () => {
        this.props.handleDismiss();
      },
    });
  };

  render() {
    const bgColor = '#333333' /* black */;
    const buttonBgColor = '#ffffff';
    const { handleDismiss } = this.props;
    return (
      <HeaderHeight>
        {(headerHeight) => (
          <Sticky dangerouslySetZIndex={{ __zIndex: 2 }} top={headerHeight}>
            <Box
              dangerouslySetInlineStyle={{
                __style: {
                  backgroundColor: bgColor,
                },
              }}
              display="flex"
              height={72}
              justifyContent="between"
              paddingX={7}
              paddingY={3}
            >
              <Box alignSelf="center">
                <Text color="white" weight="bold">
                  <span style={{ fontSize: '16px' }}>{this.getText()}</span>
                </Text>
              </Box>
              {this.state.network === '' && (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="between"
                  marginRight={-3}
                  minWidth={290}
                >
                  <SocialConnectButton
                    buttonBackgroundColor={buttonBgColor}
                    buttonText={this.props.connectWithGoogle}
                    socialMedia="gplus"
                    handleSocialConnectClick={this.handleSocialConnectClick}
                  />
                  <Box alignSelf="center">
                    <IconButton
                      accessibilityLabel={i18n._('Close', 'accessible label for close button')}
                      icon="cancel"
                      onClick={handleDismiss}
                      size="sm"
                    />
                  </Box>
                </Box>
              )}
              {this.state.network !== '' && (
                <Box marginRight={-3}>
                  <IconButton
                    accessibilityLabel={i18n._('Close', 'accessible label for close button')}
                    iconColor="white"
                    icon="cancel"
                    onClick={handleDismiss}
                    size="xs"
                  />
                </Box>
              )}
            </Box>
          </Sticky>
        )}
      </HeaderHeight>
    );
  }
}

export default compose(withExperienceClient)(SocialConnectUpsellHero);
